(function () {
  'use strict';

  // =========================================================================
  // WEB COMPONENT – Banner Info-Popover (<cgp-banner-info>)
  // =========================================================================

  class CgpBannerInfo extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('.cgp-banner__info-toggle');
      this.popoverEl = this.querySelector('.cgp-banner__info-popover');
      if (!this.toggleBtn || !this.popoverEl) return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.toggleBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.popoverEl.hidden) {
          this.open();
        } else {
          this.close();
        }
      });
    }

    disconnectedCallback() {
      this.removeGlobalListeners();
    }

    open() {
      this.popoverEl.hidden = false;
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.popoverEl.hidden = true;
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      this.removeGlobalListeners();
    }

    removeGlobalListeners() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.toggleBtn.focus();
      }
    }
  }

  if (!customElements.get('cgp-banner-info')) {
    customElements.define('cgp-banner-info', CgpBannerInfo);
  }

  // =========================================================================
  // WEB COMPONENT – Produkt-Slider (<cgp-product-slider>) — DEV-2026-0270
  //
  // Gewischt wird nativ per scroll-snap; diese Komponente steuert nur die
  // Desktop-Pfeile und ihren Aktiv-Zustand. Ohne JS bleibt der Slider damit
  // voll benutzbar — die Pfeile starten im Markup deshalb als disabled und
  // werden hier freigeschaltet.
  // =========================================================================

  class CgpProductSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cgp-pslider-track]');
      this.prevBtn = this.querySelector('[data-cgp-pslider-prev]');
      this.nextBtn = this.querySelector('[data-cgp-pslider-next]');
      if (!this.track) return;

      this.updateArrows = this.updateArrows.bind(this);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByPage(1));
      }

      this.track.addEventListener('scroll', this.updateArrows, { passive: true });

      // Mit dem Laden der Bilder ändert sich die Scrollbreite — deshalb
      // beobachten statt einmalig messen.
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(this.updateArrows);
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', this.updateArrows);
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.updateArrows);
    }

    /** Eine Seite = sichtbare Breite minus ein Stück Überlappung, damit beim
     *  Weiterklicken der Anschluss sichtbar bleibt. */
    scrollByPage(richtung) {
      var schritt = Math.max(this.track.clientWidth - 40, 120);
      this.track.scrollBy({ left: richtung * schritt, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn && !this.nextBtn) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var links = this.track.scrollLeft;
      // 2px Toleranz: Browser runden Sub-Pixel-Scrollpositionen unterschiedlich,
      // ohne Puffer bleibt der Pfeil am Ende manchmal aktiv.
      if (this.prevBtn) this.prevBtn.disabled = links <= 2;
      if (this.nextBtn) this.nextBtn.disabled = links >= max - 2;
    }
  }

  if (!customElements.get('cgp-product-slider')) {
    customElements.define('cgp-product-slider', CgpProductSlider);
  }

  var section = document.querySelector('.collection-grid-pro');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var defaultSort = '';
  var drawerEl = section.querySelector('[data-filter-drawer]');
  if (drawerEl) {
    defaultSort = drawerEl.dataset.defaultSort || '';
  }

  // =========================================================================
  // HELPERS
  // =========================================================================

  function qs(sel, ctx) { return (ctx || section).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || section).querySelectorAll(sel); }

  function cgpDebounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  // =========================================================================
  // DRAWER – Open / Close (Event Delegation)
  // =========================================================================

  function openDrawer() {
    var drawer = qs('[data-filter-drawer]');
    var backdrop = qs('[data-drawer-backdrop]');
    if (!drawer) return;

    var desktop = isDesktop();

    if (!desktop) {
      if (backdrop) backdrop.classList.add('is-active');
      // iOS: position fixed + width 100% prevents background scroll reliably
      document.body.dataset.scrollY = window.scrollY;
      document.body.style.top = '-' + window.scrollY + 'px';
      document.body.classList.add('overflow-hidden');
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      // Desktop: Push grid aside
      var gridContainer = qs('[data-cgp-grid-container]');
      if (gridContainer) gridContainer.classList.add('cgp-grid--pushed');
      // Banner-Section mitschieben
      var banner = document.querySelector('.collection-hero');
      if (banner) banner.classList.add('cgp-banner--pushed');
    }

    drawer.offsetHeight; // force reflow
    drawer.classList.add('is-active');

    if (typeof trapFocus === 'function') {
      trapFocus(drawer, qs('[data-close-drawer]', drawer));
    }
  }

  function closeDrawer() {
    var drawer = qs('[data-filter-drawer]');
    var backdrop = qs('[data-drawer-backdrop]');
    if (!drawer) return;

    drawer.classList.remove('is-active');

    var desktop = isDesktop();

    if (desktop) {
      // Desktop: Remove grid push
      var gridContainer = qs('[data-cgp-grid-container]');
      if (gridContainer) gridContainer.classList.remove('cgp-grid--pushed');
      var banner = document.querySelector('.collection-hero');
      if (banner) banner.classList.remove('cgp-banner--pushed');
    } else {
      // Mobile: Remove backdrop and unlock scroll
      if (backdrop) {
        backdrop.classList.remove('is-active');
      }
      // iOS: restore scroll position after unlocking
      var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
      document.body.classList.remove('overflow-hidden');
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }
  }

  // Event Delegation on section for all drawer interactions
  section.addEventListener('click', function (e) {
    var target = e.target;

    // Open drawer
    if (target.closest('[data-open-filter-drawer]')) {
      openDrawer();
      return;
    }

    // Close drawer
    if (target.closest('[data-close-drawer]')) {
      closeDrawer();
      return;
    }

    // Backdrop click
    if (target.closest('[data-drawer-backdrop]')) {
      closeDrawer();
      return;
    }

    // Apply filters
    if (target.closest('[data-apply-filters]')) {
      applyFilters();
      return;
    }

    // Clear all
    if (target.closest('[data-clear-all]')) {
      clearAllFilters();
      return;
    }

    // Grid toggle
    var toggleBtn = target.closest('[data-grid-cols]');
    if (toggleBtn) {
      handleGridToggle(toggleBtn);
      return;
    }

    // Load more
    if (target.closest('[data-load-more-btn]')) {
      loadMore();
      return;
    }

    // Back to top
    if (target.closest('[data-back-to-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  });

  // Escape key closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = qs('[data-filter-drawer]');
      if (drawer && drawer.classList.contains('is-active')) {
        closeDrawer();
      }
    }
  });

  // Desktop: Click outside drawer to close
  document.addEventListener('click', function (e) {
    if (!isDesktop()) return;
    var drawer = qs('[data-filter-drawer]');
    if (!drawer || !drawer.classList.contains('is-active')) return;
    if (e.target.closest('[data-filter-drawer]') || e.target.closest('[data-open-filter-drawer]')) return;
    closeDrawer();
  });

  // =========================================================================
  // PRICE RANGE SLIDER
  // =========================================================================

  function initPriceSliders() {
    var drawer = qs('[data-filter-drawer]');
    if (!drawer) return;

    var container = drawer.querySelector('[data-price-range]');
    if (!container) return;

    var rangeMin = parseFloat(container.dataset.rangeMin) || 0;
    var rangeMax = parseFloat(container.dataset.rangeMax) || 10000;

    var minSlider = container.querySelector('[data-price-min-slider]');
    var maxSlider = container.querySelector('[data-price-max-slider]');
    var minInput = container.querySelector('[data-price-min-input]');
    var maxInput = container.querySelector('[data-price-max-input]');
    var sliderEl = container.querySelector('.cgp-price-range__slider');

    if (!minSlider || !maxSlider) return;

    function updateFill() {
      var min = parseFloat(minSlider.value);
      var max = parseFloat(maxSlider.value);
      var range = rangeMax - rangeMin;
      if (range <= 0) return;
      var leftPct = ((min - rangeMin) / range) * 100;
      var rightPct = ((max - rangeMin) / range) * 100;
      if (sliderEl) {
        sliderEl.style.setProperty('--fill-left', leftPct + '%');
        sliderEl.style.setProperty('--fill-right', rightPct + '%');
      }
    }

    function updateZIndex() {
      var midpoint = (rangeMin + rangeMax) / 2;
      if (parseFloat(minSlider.value) > midpoint) {
        minSlider.style.zIndex = '2';
        maxSlider.style.zIndex = '1';
      } else {
        minSlider.style.zIndex = '2';
        maxSlider.style.zIndex = '1';
      }
    }

    // Convert slider cents to euro display value for text input
    function centsToEuro(cents) {
      var val = cents / 100;
      return Math.round(val).toString();
    }

    // Convert euro text input to cents for slider
    function euroToCents(str) {
      var cleaned = str.replace(',', '.').replace(/[^\d.]/g, '');
      var val = parseFloat(cleaned);
      return isNaN(val) ? null : Math.round(val * 100);
    }

    function onMinSliderInput() {
      var min = parseFloat(minSlider.value);
      var max = parseFloat(maxSlider.value);
      if (min > max) {
        minSlider.value = max;
        min = max;
      }
      if (minInput) minInput.value = centsToEuro(min);
      updateFill();
      updateZIndex();
    }

    function onMaxSliderInput() {
      var min = parseFloat(minSlider.value);
      var max = parseFloat(maxSlider.value);
      if (max < min) {
        maxSlider.value = min;
        max = min;
      }
      if (maxInput) maxInput.value = centsToEuro(max);
      updateFill();
      updateZIndex();
    }

    function onMinInputChange() {
      var cents = euroToCents(minInput.value);
      if (cents === null) return;
      if (cents < rangeMin) cents = rangeMin;
      if (cents > parseFloat(maxSlider.value)) cents = parseFloat(maxSlider.value);
      minSlider.value = cents;
      minInput.value = centsToEuro(cents);
      updateFill();
      updateZIndex();
    }

    function onMaxInputChange() {
      var cents = euroToCents(maxInput.value);
      if (cents === null) return;
      if (cents > rangeMax) cents = rangeMax;
      if (cents < parseFloat(minSlider.value)) cents = parseFloat(minSlider.value);
      maxSlider.value = cents;
      maxInput.value = centsToEuro(cents);
      updateFill();
      updateZIndex();
    }

    minSlider.addEventListener('input', onMinSliderInput);
    maxSlider.addEventListener('input', onMaxSliderInput);
    if (minInput) minInput.addEventListener('change', onMinInputChange);
    if (maxInput) maxInput.addEventListener('change', onMaxInputChange);

    // Initial fill + z-index
    updateFill();
    updateZIndex();
  }

  // Initialize on load
  initPriceSliders();

  // =========================================================================
  // CLEAR ALL FILTERS
  // =========================================================================

  function clearAllFilters() {
    var drawer = qs('[data-filter-drawer]');
    if (!drawer) return;

    // Uncheck all checkboxes (including swatch inputs)
    qsa('.cgp-drawer__body input[type="checkbox"]:checked', drawer).forEach(function (cb) {
      cb.checked = false;
    });

    // Reset sort to default
    var defaultRadio = qs('.cgp-radio__input[value="' + defaultSort + '"]', drawer);
    if (defaultRadio) {
      defaultRadio.checked = true;
    }

    // Reset price range
    var priceContainer = drawer.querySelector('[data-price-range]');
    if (priceContainer) {
      var minSlider = priceContainer.querySelector('[data-price-min-slider]');
      var maxSlider = priceContainer.querySelector('[data-price-max-slider]');
      var minInput = priceContainer.querySelector('[data-price-min-input]');
      var maxInput = priceContainer.querySelector('[data-price-max-input]');

      if (minSlider) minSlider.value = priceContainer.dataset.rangeMin;
      if (maxSlider) maxSlider.value = priceContainer.dataset.rangeMax;
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';

      // Reset fill line to full range
      var sliderEl = priceContainer.querySelector('.cgp-price-range__slider');
      if (sliderEl) {
        sliderEl.style.setProperty('--fill-left', '0%');
        sliderEl.style.setProperty('--fill-right', '100%');
      }
    }

    // Trigger live preview / live filter
    isDesktop() ? debouncedLiveFilter() : debouncedPreview();
  }

  // =========================================================================
  // BUILD FILTER URL
  // =========================================================================

  function buildFilterParams() {
    var drawer = qs('[data-filter-drawer]');
    if (!drawer) return '';

    var params = new URLSearchParams();

    // Sort
    var sortRadio = qs('.cgp-radio__input:checked', drawer);
    if (sortRadio && sortRadio.value) {
      params.set('sort_by', sortRadio.value);
    }

    // Checkboxes (filters + swatch inputs)
    qsa('.cgp-drawer__body input[type="checkbox"]:checked', drawer).forEach(function (cb) {
      params.append(cb.name, cb.value);
    });

    // Price range – only send if user changed from defaults (avoids counting as active filter)
    var priceRange = drawer.querySelector('[data-price-range]');
    var minPriceInput = drawer.querySelector('[data-price-min-input]');
    var maxPriceInput = drawer.querySelector('[data-price-max-input]');
    if (priceRange && minPriceInput && maxPriceInput) {
      var rangeMin = parseInt(priceRange.getAttribute('data-range-min'), 10) || 0;
      var rangeMax = parseInt(priceRange.getAttribute('data-range-max'), 10) || 0;
      var minVal = parseFloat(minPriceInput.value) || 0;
      var maxVal = parseFloat(maxPriceInput.value) || 0;
      var defaultMin = Math.floor(rangeMin / 100);
      var defaultMax = Math.ceil(rangeMax / 100);
      if (minVal > defaultMin) {
        params.append(minPriceInput.name, minPriceInput.value);
      }
      if (maxVal < defaultMax) {
        params.append(maxPriceInput.name, maxPriceInput.value);
      }
    }

    // Search page: preserve search term in filter URLs
    var searchTerm = section.dataset.searchTerm;
    if (searchTerm) {
      params.set('q', searchTerm);
      params.set('options[prefix]', 'last');
    }

    return params.toString();
  }

  // =========================================================================
  // LIVE PREVIEW – Update product count on filter change
  // =========================================================================

  var previewController = null;

  function previewFilterCount() {
    var filterParams = buildFilterParams();
    var fetchUrl = window.location.pathname + '?' + (filterParams ? filterParams + '&' : '') + 'section_id=' + sectionId;

    // Abort previous preview request
    if (previewController) previewController.abort();
    previewController = new AbortController();

    fetch(fetchUrl, { signal: previewController.signal })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Update count in footer button
        var countSpan = qs('[data-filtered-count]');
        var newCount = doc.querySelector('[data-product-count]');
        if (countSpan && newCount) {
          var match = newCount.textContent.trim().match(/(\d+)/);
          if (match) countSpan.textContent = match[1];
        }
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          console.error('Preview error:', err);
        }
      });
  }

  var debouncedPreview = cgpDebounce(previewFilterCount, 300);

  // =========================================================================
  // DESKTOP LIVE FILTERING – Apply filters immediately without closing drawer
  // =========================================================================

  var liveFilterController = null;

  function applyFiltersLive() {
    if (!isDesktop()) return;

    var drawer = qs('[data-filter-drawer]');
    var drawerBody = drawer ? drawer.querySelector('.cgp-drawer__body') : null;
    var drawerScrollTop = drawerBody ? drawerBody.scrollTop : 0;

    var filterParams = buildFilterParams();
    var gridContainer = qs('[data-cgp-grid-container]');

    var publicUrl = window.location.pathname + (filterParams ? '?' + filterParams : '');
    var fetchUrl = window.location.pathname + '?' + (filterParams ? filterParams + '&' : '') + 'section_id=' + sectionId;

    // Subtle loading state on grid only
    if (gridContainer) {
      gridContainer.classList.add('cgp-loading-overlay', 'is-loading');
    }

    // Abort previous live filter request
    if (liveFilterController) liveFilterController.abort();
    liveFilterController = new AbortController();

    fetch(fetchUrl, { signal: liveFilterController.signal })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Update grid
        var grid = qs('[data-cgp-grid]');
        var newGrid = doc.querySelector('[data-cgp-grid]');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
        }

        // Update load more
        var loadMoreContainer = gridContainer ? gridContainer.querySelector('[data-load-more]') : null;
        var newLoadMore = doc.querySelector('[data-load-more]');
        if (loadMoreContainer) loadMoreContainer.remove();
        if (newLoadMore && gridContainer) gridContainer.appendChild(newLoadMore);

        // Update product count
        var productCount = qs('[data-product-count]');
        var newCount = doc.querySelector('[data-product-count]');
        if (newCount && productCount) {
          productCount.innerHTML = newCount.innerHTML;
          productCount.dataset.totalCount = newCount.dataset.totalCount || '';
        }

        // Update drawer content (filter counts, active states)
        var drawer = qs('[data-filter-drawer]');
        var newDrawer = doc.querySelector('[data-filter-drawer]');
        if (newDrawer && drawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          // Preserve open state
          drawer.classList.add('is-active');
          // Restore scroll position
          var newDrawerBody = drawer.querySelector('.cgp-drawer__body');
          if (newDrawerBody) newDrawerBody.scrollTop = drawerScrollTop;
        }

        // Update filter count badge in action bar
        var filterCountBadge = qs('[data-filter-count]');
        var newFilterCountBadge = doc.querySelector('[data-filter-count]');
        if (filterCountBadge && newFilterCountBadge) {
          filterCountBadge.textContent = newFilterCountBadge.textContent;
          filterCountBadge.hidden = newFilterCountBadge.hidden;
        }

        // Re-init price sliders and live preview (drawer HTML was replaced)
        initPriceSliders();
        initLivePreview();

        // Silent URL update (no history spam)
        history.replaceState(null, '', publicUrl);

        // Remove loading state
        if (gridContainer) {
          gridContainer.classList.remove('cgp-loading-overlay', 'is-loading');
        }

        // Desktop: drawer stays open, no scroll to top
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('Collection Grid Pro – Live filter error:', error);
        }
        var gridContainer = qs('[data-cgp-grid-container]');
        if (gridContainer) {
          gridContainer.classList.remove('cgp-loading-overlay', 'is-loading');
        }
      });
  }

  var debouncedLiveFilter = cgpDebounce(applyFiltersLive, 400);

  function initLivePreview() {
    var drawer = qs('[data-filter-drawer]');
    if (!drawer) return;

    var desktop = isDesktop();

    // Checkboxes, swatches, radios
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], input[type="radio"]')) {
        desktop ? debouncedLiveFilter() : debouncedPreview();
      }
    });

    // Price slider
    var minSlider = drawer.querySelector('[data-price-min-slider]');
    var maxSlider = drawer.querySelector('[data-price-max-slider]');
    var priceHandler = desktop ? debouncedLiveFilter : debouncedPreview;
    if (minSlider) minSlider.addEventListener('input', priceHandler);
    if (maxSlider) maxSlider.addEventListener('input', priceHandler);

    // Price text inputs
    var minInput = drawer.querySelector('[data-price-min-input]');
    var maxInput = drawer.querySelector('[data-price-max-input]');
    if (minInput) minInput.addEventListener('change', priceHandler);
    if (maxInput) maxInput.addEventListener('change', priceHandler);
  }

  initLivePreview();

  // =========================================================================
  // APPLY FILTERS (AJAX)
  // =========================================================================

  function applyFilters() {
    var filterParams = buildFilterParams();
    var gridContainer = qs('[data-cgp-grid-container]');

    // Build URLs
    var publicUrl = window.location.pathname + (filterParams ? '?' + filterParams : '');
    var fetchUrl = window.location.pathname + '?' + (filterParams ? filterParams + '&' : '') + 'section_id=' + sectionId;

    // Show loading state
    if (gridContainer) {
      gridContainer.classList.add('cgp-loading-overlay', 'is-loading');
    }

    fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Update grid
        var grid = qs('[data-cgp-grid]');
        var newGrid = doc.querySelector('[data-cgp-grid]');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
        }

        // Update load more
        var gridContainer = qs('[data-cgp-grid-container]');
        var loadMoreContainer = gridContainer ? gridContainer.querySelector('[data-load-more]') : null;
        var newLoadMore = doc.querySelector('[data-load-more]');
        if (loadMoreContainer) {
          loadMoreContainer.remove();
        }
        if (newLoadMore && gridContainer) {
          gridContainer.appendChild(newLoadMore);
        }

        // Update product count
        var productCount = qs('[data-product-count]');
        var newCount = doc.querySelector('[data-product-count]');
        if (newCount && productCount) {
          productCount.innerHTML = newCount.innerHTML;
          productCount.dataset.totalCount = newCount.dataset.totalCount || '';
        }

        // Update drawer content (filter counts, active states, product count in button)
        var drawer = qs('[data-filter-drawer]');
        var newDrawer = doc.querySelector('[data-filter-drawer]');
        if (newDrawer && drawer) {
          drawer.innerHTML = newDrawer.innerHTML;
        }

        // Update filter count badge in action bar
        var filterCountBadge = qs('[data-filter-count]');
        var newFilterCountBadge = doc.querySelector('[data-filter-count]');
        if (filterCountBadge && newFilterCountBadge) {
          filterCountBadge.textContent = newFilterCountBadge.textContent;
          filterCountBadge.hidden = newFilterCountBadge.hidden;
        }

        // Re-init price sliders and live preview (drawer HTML was replaced)
        initPriceSliders();
        initLivePreview();

        // Update URL
        history.pushState(null, '', publicUrl);

        // Remove loading state
        if (gridContainer) {
          gridContainer.classList.remove('cgp-loading-overlay', 'is-loading');
        }

        // Close drawer
        closeDrawer();

        // Scroll to top of page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (error) {
        console.error('Collection Grid Pro – Filter error:', error);
        var gridContainer = qs('[data-cgp-grid-container]');
        if (gridContainer) {
          gridContainer.classList.remove('cgp-loading-overlay', 'is-loading');
        }
      });
  }

  // =========================================================================
  // GRID TOGGLE (Mobile)
  // =========================================================================

  function handleGridToggle(activeBtn) {
    var cols = activeBtn.dataset.gridCols;

    // Update active state
    qsa('[data-grid-cols]').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    activeBtn.classList.add('is-active');
    activeBtn.setAttribute('aria-pressed', 'true');

    // Toggle grid class
    var grid = qs('[data-cgp-grid]');
    if (grid) {
      grid.classList.remove('cgp-grid--1-col-mobile', 'cgp-grid--2-col-mobile');
      grid.classList.add('cgp-grid--' + cols + '-col-mobile');
    }
  }

  // =========================================================================
  // LOAD MORE (AJAX Pagination)
  // =========================================================================

  function loadMore() {
    var loadMoreBtn = qs('[data-load-more-btn]');
    if (!loadMoreBtn || loadMoreBtn.disabled) return;

    var nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) return;

    // Loading state
    loadMoreBtn.disabled = true;
    var textEl = qs('[data-load-more-text]', loadMoreBtn);
    if (textEl) textEl.textContent = 'Laden...';
    loadMoreBtn.classList.add('cgp-load-more__btn--loading');

    var fetchUrl = nextUrl + (nextUrl.includes('?') ? '&' : '?') + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Get new product items
        var grid = qs('[data-cgp-grid]');
        var newGrid = doc.querySelector('[data-cgp-grid]');
        if (newGrid && grid) {
          var newItems = newGrid.querySelectorAll('.cgp-grid__item');
          newItems.forEach(function (item) {
            item.classList.add('cgp-grid__item--entering');
            grid.appendChild(item);
            // Trigger fade-in after append
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                item.classList.remove('cgp-grid__item--entering');
              });
            });
          });
        }

        // Update displayed count
        var displayedCountEl = qs('[data-displayed-count]');
        if (displayedCountEl) {
          var grid = qs('[data-cgp-grid]');
          var currentItems = grid ? grid.querySelectorAll('.cgp-grid__item').length : 0;
          displayedCountEl.textContent = currentItems;
        }

        // Check for next page
        var newLoadMoreBtn = doc.querySelector('[data-load-more-btn]');
        if (newLoadMoreBtn) {
          loadMoreBtn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
          loadMoreBtn.disabled = false;
          if (textEl) textEl.textContent = 'Mehr laden';
          loadMoreBtn.classList.remove('cgp-load-more__btn--loading');
        } else {
          // No more pages
          var loadMoreContainer = qs('[data-load-more]');
          if (loadMoreContainer) loadMoreContainer.remove();
        }

      })
      .catch(function (error) {
        console.error('Collection Grid Pro – Load more error:', error);
        loadMoreBtn.disabled = false;
        if (textEl) textEl.textContent = 'Mehr laden';
        loadMoreBtn.classList.remove('cgp-load-more__btn--loading');
      });
  }

  // =========================================================================
  // BACK TO TOP
  // =========================================================================

  (function initBackToTop() {
    var backToTop = qs('[data-back-to-top]');
    if (!backToTop) return;

    var scrollThreshold = 800;
    var isVisible = false;

    function handleScroll() {
      var shouldShow = window.scrollY > scrollThreshold;
      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        backToTop.classList.toggle('is-visible', isVisible);
      }
    }

    var checkScroll = typeof throttle === 'function'
      ? throttle(handleScroll, 200)
      : handleScroll;

    window.addEventListener('scroll', checkScroll, { passive: true });
  })();

  // =========================================================================
  // ACTION BAR STICKY POSITION (tracks header visibility)
  // =========================================================================

  (function initActionBarSticky() {
    var actionBar = qs('[data-cgp-action-bar]');
    if (!actionBar) return;

    // Find header section wrapper (multiple fallback selectors)
    var headerSection = document.querySelector('.section-header')
      || document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('sticky-header');
    if (!headerSection) return;

    function updateActionBarTop() {
      var rect = headerSection.getBoundingClientRect();
      var top = Math.min(rect.bottom, headerSection.offsetHeight);
      actionBar.style.top = Math.max(0, top) + 'px';
    }

    var rafPending = false;
    window.addEventListener('scroll', function () {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(function () {
          updateActionBarTop();
          rafPending = false;
        });
      }
    }, { passive: true });

    window.addEventListener('resize', updateActionBarTop);
    updateActionBarTop();
  })();

  // =========================================================================
  // BROWSER BACK/FORWARD (popstate)
  // =========================================================================

  window.addEventListener('popstate', function () {
    location.reload();
  });

  // =========================================================================
  // RESIZE HANDLER – Clean up state when switching breakpoints
  // =========================================================================

  var wasDesktop = isDesktop();
  window.addEventListener('resize', cgpDebounce(function () {
    var nowDesktop = isDesktop();
    if (wasDesktop !== nowDesktop) {
      var drawer = qs('[data-filter-drawer]');
      if (drawer && drawer.classList.contains('is-active')) {
        closeDrawer();
      }
      wasDesktop = nowDesktop;
    }
  }, 200));

})();
